module.exports = __webpack_public_path__ + "static/media/presentation_3.e5c0d94a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/transplant/icons/presentation_3.svg
// module id = 648
// module chunks = 1